import { toast } from "../components/toast";
import { CliUser } from "../types/users";
import { ErrMsg } from "./backend";
import { debuglog } from "./utils";
type set<K> = React.Dispatch<React.SetStateAction<K>>

export function failure<A>(res: A, setToast: set<toast | undefined>): res is A & Exclude<ErrMsg, { userIsAuthed: boolean }> {
  if (res && typeof res === "object" && "msg" in res) {
    setToast({ text: res.msg as string, color: "danger" })
    debuglog("failure (other)")
    return true
  }
  return false;
}

export function unauth<A>(res: A, user: CliUser | null | undefined, setToast: set<toast | undefined>): res is A & { userIsAuthed: boolean } {
  if (res && typeof res === "object" && "userIsAuthed" in res) {
    debuglog("failure (unauth)")

    if (user) {
      setToast({ text: "Looks like your session expired! Log in and try again.", color: "danger" })
    }

    return true;
  }
  return false;
}

export function setData<K>(res: K | ErrMsg, setToast: set<toast | undefined>, user: CliUser | null | undefined, setUser: set<CliUser | null | undefined>, onFailure?: (data: ErrMsg) => any): res is K {
  if (unauth(res, user, setToast)) {
    setUser(undefined);
    return false;
  };
  if (failure(res, setToast)) {
    if (onFailure) {
      onFailure(res)
    }
    return false;
  }
  return true;
}